import React from 'react';

function Contact() {
	  return (
		      <div className="container">
		        <h1>Contact</h1>
		        <ol>
		        <li><a href= "mailto: simon.mille@adaptcentre.ie">simon.mille@adaptcentre.ie</a></li>
		        <li><a href= "mailto: michela.lorandi@adaptcentre.ie">michela.lorandi@adaptcentre.ie</a></li>
		        <li><a href= "mailto: massimiliano.pronesti@ibm.com">massimiliano.pronesti@ibm.com</a></li>
		        <li><a href= "mailto: craig.thomson@adaptcentre.ie">craig.thomson@adaptcentre.ie</a></li>
		        <li><a href= "mailto: rudali.huidrom@adaptcentre.ie">rudali.huidrom@adaptcentre.ie</a></li>
		        </ol>
		      </div>
		    );
}

export default Contact;

